import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VProgressCircular,{attrs:{"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":_vm.loading || _vm.showLoading}},[_c(VAvatar,{attrs:{"size":_vm.logoSize}},[_c('BrandLogo',{attrs:{"dark":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }